// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#room-list[data-v-8a397798]{max-width:1280px;margin-left:auto;margin-right:auto}#room-list .box-header[data-v-8a397798]{width:100%}#room-list .box-header .title[data-v-8a397798]{font-size:22px;font-weight:700}#room-list .box-header .add-btn[data-v-8a397798],#room-list .box-header .multi-add-btn[data-v-8a397798]{width:130px;min-width:130px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
